// Finishing a visit early
export const BILLING_PERIOD_HOUR_INCREMENTS = 0.5;
export const EARLY_GRACE_PERIOD_MINUTES = 15;
export const MINIMUM_BILLABLE_HOURS = 2;

// Finishing a visit late
export const LATE_GRACE_PERIOD_MINUTES = 25;
